//{{-- ========================================================================================== --}}
//{{-- Scripts for handling the modalnewABC modal                                                 --}}
//{{-- ========================================================================================== --}}
$(function(){
    $('#modalnewABC').safeOn('hidden.bs.modal', function(){
        //{{-- Anything that needs to be done when the modal is closed;--}}
    });
    $('#modalnewABC').safeOn('show.bs.modal', function(){
        //{{-- Anything that needs to be done just before the modal is shown; --}}
    });
});

//{{-- Callback function for modalnewABC close - note that the user has not changed --}}
window.newABCModalCallback = function(abcType, lastSaved) {
    $('#modalnewABC').modal('hide');
    if (abcType == 'account') {
        oldAccountSelected = lastSaved;
        loadAbcSelects('account',  $('.slAccount'),  abcUserId, oldAccountSelected);
        loadAbcSelects('brand',    $('.slBrand'),    oldAccountSelected, oldBrandSelected);
        loadAbcSelects('campaign', $('.slCampaign'), oldBrandSelected, oldCampaignSelected);
    } else if (abcType == 'brand') {
        oldBrandSelected = lastSaved;
        loadAbcSelects('brand',    $('.slBrand'),    $('.slAccount').val(), oldBrandSelected);
        loadAbcSelects('campaign', $('.slCampaign'), oldBrandSelected, oldCampaignSelected);
    } else if (abcType == 'campaign') {
        oldCampaignSelected = lastSaved;
        loadAbcSelects('campaign', $('.slCampaign'), $('.slBrand').val(), oldCampaignSelected);
    }
}

//{{-- ========================================================================================== --}}
//{{-- Scripts for handling the ACBRCA select fields                                              --}}
//{{-- ========================================================================================== --}}          
var abcUserId;

$(function(){
    $('.slAccount').change(function(evt) { 
        evt.stopImmediatePropagation();                     //{{-- Prevent click event triggering once for every parent container --}}
        processAccountChange(); 
    });
    $('.slBrand').change(function(evt) { 
        evt.stopImmediatePropagation();                     //{{-- Prevent click event triggering once for every parent container --}}
        processBrandChange(); 
    });
    $('.slCampaign').change(function(evt) { 
        evt.stopImmediatePropagation();                     //{{-- Prevent click event triggering once for every parent container --}}
        processCampaignChange(); 
    });
}); 

//{{-- Process change on account select --}}
window.processAccountChange = function(acChgCallback) {
    oldBrandSelected = '';
    oldCampaignSelected = '';
    if ($('.slAccount').val() == -1) {
        //{{-- User chose option to create new account --}}
        $('#newABC').html(acs_new_account);
        initModalnewABC('account', abcUserId);
        $('#modalnewABC').modal();
    } else if ($('.slAccount').val() == 0) {
        //{{-- User selected no account, we must clear the other two selects --}}
        $('.slBrand').html('<option selected="selected" value=0>&lt;- ' + acs_choose_acct_first + '</option>');
        $('.slCampaign').html('<option selected="selected" value=0>&lt;- ' + acs_choose_brand_first + '</option>');
    } else {
        //{{-- User selected an account, load the brand and campaign selects --}}
        loadAbcSelects('brand', $('.slBrand'), $('.slAccount').val(), oldBrandSelected);
        setTimeout(function() {
            loadAbcSelects('campaign', $('.slCampaign'), $('.slBrand').val(), oldCampaignSelected)
        }, 500);
    }
    //{{-- In the end, run the callback function --}}
    if (isThere(acChgCallback)) window['acChgCallback'];
};

//{{-- Process change on brand select --}}
window.processBrandChange = function(brChgCallback) {
    oldCampaignSelected = '';
    if ($('.slBrand').val() == -1) {
        //{{-- User chose option to create new brand --}}
        $('#newABC').html(acs_new_brand);
        initModalnewABC('brand', $('.slAccount').val());
        $('#modalnewABC').modal();
    } else if ($('.slBrand').val() == 0) {
        //{{-- User selected no brand, we must clear the campaign select --}}
        $('.slCampaign').html('<option selected="selected" value=0>&lt;- ' + acs_choose_brand_first + '</option>');
    } else {
        //{{-- User selected a brand, load the campaign select --}}
        loadAbcSelects('campaign', $('.slCampaign'), $('.slBrand').val(), oldCampaignSelected);
    }
    //{{-- In the end, run the callback function --}}
    if (isThere(brChgCallback)) window['brChgCallback'];
};

//{{-- Process change on campaign select --}}
window.processCampaignChange = function(caChgCallback) {
    if ($('.slCampaign').val() == -1) {
        //{{-- User chose option to create new campaign --}}
        $('#newABC').html(acs_new_campaign);
        initModalnewABC('campaign', $('.slBrand').val());
        $('#modalnewABC').modal();
    }
    //{{-- In the end, run the callback function --}}
    if (isThere(caChgCallback)) window['caChgCallback'];
};

//{{-- This does the initial load of the select fields and must be called from whatever page does the @include --}}
window.loadACBRCASelects = function(user_id) {
    abcUserId = user_id;
    $('.slAccount').empty();
    $('.slBrand').empty();
    $('.slCampaign').empty();
    loadAbcSelects('account', $('.slAccount'), abcUserId, oldAccountSelected);
    if ( oldBrandSelected )    loadAbcSelects('brand', $('.slBrand'), oldAccountSelected, oldBrandSelected);
    if ( oldCampaignSelected ) loadAbcSelects('campaign', $('.slCampaign'), oldBrandSelected, oldCampaignSelected);
    showAbcSelects(user_id);
}

//{{-- Show or hide the select fields according to the user's company's usage --}}
function showAbcSelects(user_id) {
    $.get('/abcusage/' + user_id, function(data){
        usesAccounts = data[0];
        usesBrands = data[1];
        usesCampaigns = data[2];
        //{{-- Show or hide the select fields - NOTE: if class abcselect is also used in the div on the page that does the @include, showing the entire div is controlled from here --}}
        if (!usesAccounts) {
            $('.abcselect').hide();
        } else {
            $('.abcselect').show();
            if (!usesBrands) {
                $('.slBrandLbl').hide();   
                $('.slBrand').hide();
                $('.slCampaignLbl').hide();
                $('.slCampaign').hide();
            } else {
                $('.slBrandLbl').show();   
                $('.slBrand').show();
                if (!usesCampaigns) {
                    $('.slCampaignLbl').hide();
                    $('.slCampaign').hide();
                } else {
                    $('.slCampaignLbl').show();
                    $('.slCampaign').show();
                }
            }
        }
    });
}

//{{-- Ajax call to load the filter selects --}}
function loadAbcSelects(field_type, field, sel_id, oldval) {       
    //{{-- Get Account description constants from database - ClientsController - This is an AJAX call, so it's asynch ! --}}
    selecttxt   = (field_type == 'account') ? acs_select_ac      : (field_type == 'brand' ? acs_select_br      : acs_select_ca);        
    createtxt   = (field_type == 'account') ? acs_create_new_ac  : (field_type == 'brand' ? acs_create_new_br  : acs_create_new_ca);
    oldSelected = parseInt(oldval);
    field.empty();
    field.append($("<option></option>").attr("value", 0).text(selecttxt));
    field.append($("<option class='text-primary')></option>").attr("value", -1).text("--- " + createtxt + " --- "));
    if (sel_id) {
        $.get('/clients/abc/' + field_type + '/' + sel_id + '/' + oldSelected, function(data){
            $.each(data['descList'], function(key, value) {
                if (value == data['oldSelect'] ) {
                    field.append($("<option></option>").attr("value", value).attr("selected", "selected").text(key));
                } else {
                    field.append($("<option></option>").attr("value", value).text(key));
                }
            });
        });
    }
}